import React, { useState } from 'react'
import { StarIcon } from '@phosphor-icons/react'

const StarRating = ({
  totalStars = 5,
  initalRating = 0,
  readOnly = false,
  size = 20,
  onRate,
  showStarLabels = false,
  className = "",
  setRating
}) => {
  const [localRating, setLocalRating] = useState(initalRating)

  const starLabels = ['Bad', 'So-so', 'Okay', 'Good', 'Great']

  const handleRating = (rate) => {
    if (readOnly) return;

    setLocalRating(rate);
    setRating(rate);
    if (onRate) {
      onRate();
    }
  };

  return (
    <React.Fragment>
      <div className={`flex space-x-1 items-center ${className}`}>
        {[...Array(totalStars)].map((_, index) => {
          const starValue = index + 1;

          return (
            <div className={`flex flex-col items-center`} key={starValue}>
              <StarIcon
                size={size}
                weight={starValue <= localRating ? "fill" : "light"}
                className={`${!readOnly && "cursor-pointer"} ${
                  starValue <= localRating ? "text-primary" : "text-gray-300"
                }`}
                onClick={() => handleRating(starValue)}
              />
              {
                showStarLabels && (
                  <div>{starLabels[index]}</div>
                )
              }
            </div>
          );
        })}
      </div>
    </React.Fragment>
  );
};

export default StarRating